











import Vue from 'vue'
import InputBankName from '@/components/molecules/InputBankName.vue'

export default Vue.extend({
  name: 'BankNameOkasan',
  components: {
    InputBankName
  },
  props: {
    bankNameError: String,
    form: Object,
    showBankList: Boolean,
    banks: Array,
    bankNameOptions: Array
  },
  methods: {
    fillBankCode: function () {
      this.$emit('fillBankCode')
    },
    clearBanks: function () {
      this.$emit('clearBanks')
    },
    searchBank: function (e: HTMLElementEvent<HTMLInputElement>) {
      this.$emit('search', e)
    },
    selectBank: function (bankCode: string, bankName: string) {
      this.$emit('select', bankCode, bankName)
    },
    seenYuuchoHelpMethod: function (value: boolean) {
      this.$emit('seenYuuchoHelp', value)
    },
    clearBankBranchName: function () {
      this.$emit('clearBankBranchName')
    }
  }
})
